import { getLocale } from "../runtime";

const sv_subcategories = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `underkategorier`
};

const subcategories = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_subcategories(inputs)
	return "subcategories";
};

export { subcategories as "subcategories" };